import { useEffect, useRef } from "react"
import { animate } from "motion"

const TypingEffect = ({ text, speed = 35, delay = 0 }) => {
  const textRef = useRef()

  useEffect(() => {
    const textArray = text.split("")
    const textContainer = textRef.current
    if (textContainer) {
      textContainer.innerHTML = "" // Clear existing content

      setTimeout(() => {
        textArray.forEach((char, index) => {
          // Create a span for each character
          const span = document.createElement("span")
          span.textContent = char
          span.style.opacity = "0"
          textContainer.appendChild(span)

          // Animate the opacity of each character
          animate(
            span,
            { opacity: [0, 1] },
            { delay: index * (speed / 1000), duration: 0.2 }
          )
        })
      }, delay)
    }
  }, [text, speed])

  return <div ref={textRef} />
  // return <div ref={textRef} style={{ fontFamily: "monospace", fontSize: "24px" }} />
}

export default TypingEffect
